module.exports = __webpack_public_path__ + "assets/img/00175.71dc9eb7.png";